export enum Api {
  // Auth api
  AUTH_BASE_URL = '/api/v1/auth',
  LOGIN = '/login',
  LOGOUT = '/logout',
  FORGOT_PASSWORD = '/forgot-password',
  RESET_PASSWORD = '/reset-password',

  // Workflows api
  RULE_ENGINE_BASE_URL = '/api/v1',

  /** Connections service (connectors + saved queries), same host as `VITE_BASE_URL`. */
  CONNECTIONS_API_V1 = '/connections/api/v1',
  WORKFLOWS = '/workflows',
  LOOKUPS = '/lookups',
  EDIT_WORKFLOW = '/workflows/edit',

  // Other apis
  USERS_BASE_URL = '/v1/users',
  SUBSCRIPTION_BASE_URL = '/v1/subscription',
  ACTIVE_INACTIVE_GSTINS = '/active-inactive-gstins',

  // Workflow endpoints
  WORKFLOWS_CREATE = '/workflows/create',

  // Input component endpoints
  FETCH_INPUT_COMPONENT = '/workflowComponent/fetchInputComponent',
  UPDATE_INPUT_COMPONENT = '/workflowComponent/updateInputComponent',

  // Ruleset component endpoints
  ADD_RULESET_COMPONENT = '/workflowComponent/addRulesetComponent',
  UPDATE_RULESET_COMPONENT = '/workflowComponent/updateRulesetComponent',
  DELETE_RULESET_COMPONENT = '/workflowComponent/deleteRulesetComponent',
  FETCH_RULESET_COMPONENT = '/workflowComponent/fetchRulesetComponent',

  // Cases api
  CASES = '/bff/cases',
  CASES_V2 = '/cases',
  AUDIT_CASE = '/case-audits',
}
